import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './pages/core/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { NavComponent } from './pages/core/navigation/nav.component';
import { ResetPasswordComponent } from './pages/core/reset-password/reset-password.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'Login'},
  { path: 'Login', component: LoginComponent },
  { path: 'reset', component: ResetPasswordComponent },
  { path: 'Home', component: NavComponent, loadChildren: () => import('./pages/core/navigation/nav.module').then(m => m.NavModule), canActivate: [AuthGuard]},
  { path: '**', pathMatch: 'full', redirectTo: 'Login' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})

export class LoginRoutingModule { }
